import {
  CREATE_NEW_USER_SUCCESS,
  CREATE_NEW_USER_FAILURE,
  CREATE_NEW_USER_REQUEST,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAILURE,
  FETCH_USER_REQUEST,
  LOGOUT_USER,
  ADD_ROLE_TO_USER_SUCCESS,
  ADD_ROLE_TO_USER_FAILURE,
  ADD_ROLE_TO_USER_REQUEST,
  UPDATE_USER,
} from '../constants';


const userInitialState = {
  user: null,
  isLoggedIn: false,
  isUserFetched: false,
  isUserFetching: false,
  isCreatingNewUser: false,
  isAddingRoleToUser: false,
  isAddedRoleToUser: false,
};

const updateUser = (state, action) => ({
  ...state,
  ...action.payload,
});

const createUserRequest = (state) => ({
  ...state,
  isCreatingNewUser: true,
});
const createUserSuccess = (state, action) => ({
  ...state,
  district: {
    ...state.user,
    user: action.payload,
  },
  isCreatingNewUser: false,
});
const createUserFailure = (state) => ({
  ...state,
  isCreatingNewUser: false,
});

const userRequest = (state) => ({
  ...state,
  isuserFetching: true,
});
const userSuccess = (state, action) => ({
  ...state,
  isUserFetching: false,
  isLoggedIn: true,
  isUserFetched: true,
  user: action.payload,
});
const userFailure = (state) => ({
  ...state,
  isUserFetching: false,
  isLoggedIn: false,
  isUserFetched: false,
});
const logOut = (state, action) => ({
  ...state,
  isUserFetching: false,
  isLoggedIn: false,
  isUserFetched: false,
  user: null,
});
const addRoleToUserSuccess = (state) =>({
  ...state,
  isAddingRoleToUser: false,
  isAddedRoleToUser: true,
});
const addRoleToUserFailure = (state) =>({
  ...state,
  isAddingRoleToUser: false,
  isAddedRoleToUser: false,
});
const addRoleToUserRequest = (state) =>({
  ...state,
  isAddingRoleToUser: true,
  isAddedRoleToUser: false,
});

export default function reducer(state = userInitialState, action) {
  return ({
    [CREATE_NEW_USER_SUCCESS]: createUserSuccess,
    [CREATE_NEW_USER_FAILURE]: createUserFailure,
    [CREATE_NEW_USER_REQUEST]: createUserRequest,
    [FETCH_USER_SUCCESS]: userSuccess,
    [FETCH_USER_FAILURE]: userFailure,
    [FETCH_USER_REQUEST]: userRequest,
    [LOGOUT_USER]: logOut,
    [ADD_ROLE_TO_USER_SUCCESS]: addRoleToUserSuccess,
    [ADD_ROLE_TO_USER_FAILURE]: addRoleToUserFailure,
    [ADD_ROLE_TO_USER_REQUEST]: addRoleToUserRequest,
    [UPDATE_USER]: updateUser,
  }[action.type] || (s => s)) (state, action);
}



// WEBPACK FOOTER //
// src/reducers/user.js